import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiFetch, ApiError } from "../api/client";
import { ME_KEY } from "../api/hooks/useMe";
import type { Me } from "../api/types";

interface SignUpResponse {
  readonly user: Me;
  readonly workspace: { readonly slug: string };
}

export function useSignUp() {
  const qc = useQueryClient();
  return useMutation<
    Me,
    ApiError,
    { email: string; password: string; displayName: string; secretWord: string }
  >({
    mutationFn: async (input) => {
      const res = await apiFetch<SignUpResponse>("/auth/sign-up", {
        method: "POST",
        body: input,
      });
      return res.user;
    },
    onSuccess: (me) => {
      qc.setQueryData(ME_KEY, me);
      qc.invalidateQueries({ queryKey: ["workspaces"] });
    },
  });
}
